<template>
  <div class="main-header">
    <!--logo 区域-->
    <div class="main-header-logo">
      <!--<img :src="'../assets/main/icon_logo.png'" />-->
      <img :src="`${logoPath}?${timestamp}`" />
    </div>
    <!--应用区域-->
    <div class="main-header-app">
      <ul v-if="apps.length > 1">
        <template v-for="(item, index) in apps">
          <li
            :class="item.id === selectedApp.id ? 'app-active' : ''"
            @click="changeApp(index, item, apps)"
            v-if="index < 5"
          >
            {{ item.title }}
          </li>
        </template>
        <li v-if="apps.length > 5" v-clickoutside="handleCloseMoreBox">
          <div class="more" @click="isShowMoreApp = !isShowMoreApp">
            <span
              class="more-txt"
              :class="
                JSON.stringify(moreAppArr).indexOf(selectedApp.id) > -1
                  ? 'app-active'
                  : ''
              "
              >更多</span
            >
            <i class="main-header-dropdown-icon" v-if="!isShowMoreApp"></i>
            <i class="main-header-dropdown-icon-up" v-if="isShowMoreApp"></i>
          </div>
          <div class="more-app-box animated fadeInDown" v-if="isShowMoreApp">
            <ul>
              <li v-for="(item, index) in moreAppArr">
                <div
                  class="more-app-item"
                  @click="changeApp(index, item, moreAppArr)"
                >
                  <div class="more-app-icon-wrap">
                    <div class="more-app-icon">
                      <img :src="item.icon" />
                    </div>
                  </div>
                  <div class="more-app-title">{{ item.title }}</div>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <!--右侧用户信息区域-->
    <div class="main-header-avator" v-clickoutside="handleClose">
      <div class="main-header-avator-con">
        <Row type="flex" justify="end" align="middle" style="height: 100%">
          <div class="avator-con-content" @click="clickHead">
            <span class="avator-con-user-name">您好，{{ name }}</span>
            <Avatar
              :src="userHeadImg"
              class="avator-con-user-img"
              size="large"
            ></Avatar>
              <i class="main-header-dropdown-icon" v-if="!isShowDropdownMenu"></i>
              <i
                class="main-header-dropdown-icon-up"
                v-if="isShowDropdownMenu"
              ></i>
          </div>
          <div
            class="avator-con-dropdown-menu animated fadeInDown"
            v-if="isShowDropdownMenu"
          >
            <ul>
              <!-- <li>
                <span v-on:click="gotoRegionPlatform">区域平台</span>
              </li> -->
              <li>
                <span v-on:click="editPassWord">修改密码</span>
              </li>
              <li>
                <span v-on:click="logout">退出登录</span>
              </li>
            </ul>
          </div>
        </Row>
      </div>
    </div>
    <edit-password
      ref="editPassword"
      :editModalVisible="editModalVisible"
      :showSimpleTip="false"
      :showExitBtn="false"
      :showCloseBtn="true"
      @close-modal="closeModal('editModalVisible')"
    ></edit-password>
  </div>
</template>

<script>
import { renderRouterByMenu } from "../util/menu";
import { removeToken, removeUserId } from "@/library/js/auth.js";
import { valInDeep } from "@/library/js/array.js";
import { mapGetters } from "vuex"; // 引入状态共享
import noAuthApps from "@/util/appConfig";
import { replaceParams } from "@/util/menu";
import editPassword from "@/components/EditPassword.vue";
import Cookies from "js-cookie";
export default {
  name: "topNav",
  components: {
    editPassword,
  },
  data() {
    return {
      isShowMoreApp: false,
      isShowDropdownMenu: false,
      logoPath: process.env.VUE_APP_HEADER_LOGO_PATH,
      timestamp: new Date().getTime(),
      editModalVisible: false,
      channel: process.env.VUE_APP_CHANNEL
    };
  },
  computed: {
    ...mapGetters(["apps", "selectedApp", "userHeadImg", "name"]),
    moreAppArr() {
      return this.apps.slice(5);
    },
  },
  methods: {
    /**
     * 切换应用
     */
    changeApp(index, item, appArr) {
      this.handleCloseMoreBox();
      if (item.open_mode == 0) {
        let menusData = renderRouterByMenu(appArr[index].menuTreeList, true);
        this.$store.commit("menu/SET_MENUS", menusData);
        this.$store.dispatch("menu/setSelectedApp", appArr[index]);

        if (menusData.length > 0) {
          let path = menusData[0].path || menusData[0].children[0].path;
          let title = menusData[0].title || menusData[0].children[0].title;

          let targetMenu = valInDeep(menusData, path, "path", "children");
          if (targetMenu.length > 0) {
            if (targetMenu[0].children.length > 0) {
              this.$store.dispatch(
                "menu/setSelectedMenuId",
                targetMenu[0].children[0].id
              );
            } else {
              this.$store.dispatch("menu/setSelectedMenuId", targetMenu[0].id);
            }
            //设置头部面包屑导航
            this.$util.setCurrentPath(this, this.path, this.$route.params);
          }

          this.$util.setCurrentPath(this, path, {});
          // this.$util.routerGo(path, title);
          this.$router.push({
            path: path,
          });
        } else {
          this.$router.push({
            path: "/base/noauth",
          });
        }
      } else {
        item.url = replaceParams(item.url);
        window.open(item.url, "_blank");
      }
    },
    /**
     * 点击其他区域关闭下拉菜单
     */
    handleClose() {
      this.isShowDropdownMenu = false;
    },
    /**
     * 点击其他区域关闭更多应用弹框
     */
    handleCloseMoreBox() {
      this.isShowMoreApp = false;
    },
    /**
     * 修改密码
     */
    editPassWord() {
      this.handleClose();
      this.editModalVisible = true;
      // let path = "/base/accountSetting?tabName=passwordTab";
      // this.$util.routerGo(path, "账号设置");
    },
    /**
     * 关闭修改密码弹框
     */
    closeModal(modalKey) {
      this[modalKey] = false;
    },
    /**
     * 退出
     */
    logout() {
      let _this = this;
      _this.$Modal.confirm({
        title: "提示",
        content: "<p>确认退出吗?</p>",
        onOk: () => {
          //清除所有cookie
          removeToken();
          removeUserId();
          Cookies.set("codeLoginState", -1);
          _this.$store.dispatch("menu/setSelectedMenuId", "");
          // window.location.href = '/' + noAuthApps[0].route_prefix + '/login';
          ssoClient.logout();
        },
      });
    },
    /**
     * 进入老版本管理后台
     */
    gotoOldManage() {
      window.open(
        process.env.VUE_APP_OLDMGEURL + "/psn/login?tag=console",
        "_blank"
      );
    },
    /**
     * 进入区域平台
     */
    gotoRegionPlatform() {
      window.open(process.env.VUE_APP_REGIONPLATFORM, "_blank");
    },
    /**
     * 用户头像点击事件
     */
    clickHead() {
      if (this.channel != "nanjing") {
        this.isShowDropdownMenu = !this.isShowDropdownMenu;
      }
    }
  },
  directives: {
    clickoutside: {
      bind: function (el, binding, vnode) {
        function documentHandler(e) {
          if (el.contains(e.target)) {
            return false;
          }
          if (binding.expression) {
            binding.value(e);
          }
        }

        el._vueClickOutside_ = documentHandler;
        document.addEventListener("click", documentHandler);
      },
      unbind: function (el, binding) {
        document.removeEventListener("click", el._vueClickOutside_);
        delete el._vueClickOutside_;
      },
    },
  },
  // mounted() {
  //     this.logoPath = process.env.VUE_APP_HEADER_LOGO_PATH
  // },
};
</script>

<style lang="scss">
@import "../style/animate/animate";

.main-header {
  position: relative;
  /*top: 0;*/
  z-index: 1000;
  width: 100%;
  height: $header-height;
  line-height: $header-height;
  color: $header-color;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 4px 0px;
  box-sizing: border-box;
  background-size: 100% 100%;
  background-image: url("../assets/main/icon_top.png");

  &-logo {
    float: left;
    display: flex;
    height: 100%;
    align-items: center;
    margin-left: 36px;

    img {
      // height: 37px;
      height: 30px;
      width: 100%;
    }
  }

  &-app {
    position: relative;
    float: left;
    margin-left: 144px;
    color: #fff;
    font-size: 16px;

    ul {
      li {
        position: relative;
        float: left;
        display: block;
        margin-right: 60px;
        cursor: pointer;
      }

      .more {
        align-items: center;
        display: flex;

        &-txt {
          margin-right: 11px;
        }
      }

      .app-active {
        font-size: 20px;
        font-weight: bold;
      }

      .more-app-box {
        position: absolute;
        top: 50px;
        right: -58px;
        width: 569px;
        min-height: 135px;
        background: #fff;
        box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
        border-radius: 0px 0px 5px 5px;
        padding: 24px 28px 10px 28px;
        color: #666;
        font-size: 18px;

        &:before {
          position: absolute;
          top: -10px;
          right: 94px;
          content: "";
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 10px solid #fff;
        }

        .more-app-item {
          cursor: pointer;
        }

        .more-app-icon-wrap {
          display: flex;
          justify-content: center;
          margin-bottom: 15px;
        }

        .more-app-icon {
          width: 39px;
          height: 39px;

          img {
            width: 100%;
          }
        }

        .more-app-title {
          line-height: 1.5;
        }

        ul {
          margin-top: 5px;

          li {
            float: left;
            display: block;
            margin-right: unset;
            margin-bottom: 24px;
            width: 128px;
            text-align: center;
          }
        }
      }
    }
  }

  &-avator {
    /*position: absolute;*/
    /*right: 0;*/
    /*top: 0;*/
    /*height: 100%;*/
    /*width: 340px;*/
    float: right;
    height: 100%;

    &-con {
      position: absolute;
      right: 30px;
      top: 0;
      height: 100%;

      .avator-con-content {
        align-items: center;
        display: flex;

        .avator-con-user-name {
          font-size: 16px;
          color: #fff;
          font-weight: bold;
        }

        .avator-con-user-img {
          background: #fff;
          margin-right: 16px;
          cursor: pointer;
          margin-left: 15px;
        }
      }

      .avator-con-dropdown-menu {
        position: absolute;
        top: 60px;
        right: 0;
        width: 169px;
        background: #fff;
        box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
        border-radius: 0px 0px 5px 5px;
        padding: 0 5px;
        color: #666;
        font-size: 14px;
        font-weight: 500;

        &:before {
          position: absolute;
          top: -10px;
          right: 40px;
          content: "";
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 10px solid #fff;
        }

        ul {
          li {
            position: relative;
            height: 60px;
            line-height: 60px;
            cursor: pointer;
            text-align: center;

            :hover {
              color: $main-color;
            }
          }

          :not(:last-child) {
            border-bottom: 1px solid #eaeaea;
          }
        }
      }
    }
  }

  &-dropdown-icon {
    width: 12px;
    height: 6px;
    background-size: 100% 100%;
    background-image: url("../assets/main/icon_up_white.png");
  }

  &-dropdown-icon-up {
    width: 12px;
    height: 6px;
    background-size: 100% 100%;
    background-image: url("../assets/main/icon_down_white.png");
  }
}
</style>
